'use strict';
applicationsSubNavbar.classy.controller({
    name: 'ResetModalController',
    inject: ['$scope', 'ResetService', 'AlertService', 'ApplicationService', 'ApplicationSideBarService', '$modalInstance', 'CheckListService'],
    init: function()
    {

        this.$.ApplicationService = this.ApplicationService;
        this.$.$modalInstance = this.$modalInstance;
        this.$.family = [];
        this.$.family[0] = {}; //Application resets
        this.$.family[1] = {}; //Family 1 resets
        this.$.family[2] = {}; //Family 2 resets
        for (var i = 0; i < this.ApplicationService.getFamCount(); i++)
        {
            for (var property in this.AlertService.getAlerts()) {
                this.$.family[i + 1][property] = false;
            }
            this.$.family[i + 1]['Income'] = true;
            this.$.family[i + 1]['Imputed_Income'] = true;
            this.$.family[i + 1]['Living_Allowance'] = true;
            this.$.family[i + 1]['Housing'] = true;
            this.$.family[i + 1]['Utilities'] = true;
            this.$.family[i + 1]['Insurances'] = true;
            this.$.family[i + 1]['Taxes'] = true;
            this.$.family[i + 1]['Allowed_Savings'] = true;
            this.$.family[i + 1]['Charity'] = true;
            this.$.family[i + 1]['Tuition'] = true;
            this.$.family[i + 1]['Items_of_Interest'] = true;
            this.$.family[i + 1]['Process'] = true;
        }
        this.$.family[0]['Award'] = true;

        this.$.versionNo = versionNo;
        this.$.AlertService = this.AlertService;
        this.$.CheckListService = this.CheckListService;
        this.$.showAlerts = 0;
        var parent = this;
        angular.forEach(this.$.AlertService.getAlerts(), function(value, key) {
            if (value.state=='success') {
                parent.$.showAlerts = 1;
                parent.$.family[1][key] = true;
                parent.$.family[2][key] = true;
            }
        });

    },
    submitReset: function()
    {
        if (this.ApplicationService.getAwardData().app[0].Status_Award==="1" || this.ApplicationService.getAwardData().app[0].Status_Reject==="1")
            this.ApplicationSideBarService.setBin('Status_Viewed');  
        this.ResetService.resetAll(this.$.family, this.$modalInstance);
    }
});